import { routesList } from '@router/Routes'

const usePathGenerator = () => {
  const getDynamicPath = (path, parameters) => {
    let generatedPath = routesList[path]
    for (let parameter in parameters) {
      generatedPath = generatedPath.replace(`:${parameter}`, parameters[parameter])
    }

    return generatedPath
  }

  return getDynamicPath
}

export default usePathGenerator